import type { FieldInfo } from "../models/fieldInfo";
import type { JourneyData } from "../models/journeyData";
import { buildUpdateTransactionRequest } from "./buildUpdateTransactionRequest";

export function requiresSecondaryId(fieldInfo: FieldInfo[]): boolean {
  return fieldInfo.some(
    (f) => f.field === "sender.secondaryIdentification.id" && f.required === true
  );
}

function getValueAtPath(obj: unknown, dotKey: string): unknown {
  let current: any = obj;
  for (const part of dotKey.split(".")) {
    if (current == null || typeof current !== "object") return undefined;
    current = current[part];
  }
  return current;
}

// Required fields the dedicated screens did not collect (their value is absent from the
// update-transaction payload). These are dumped into the Additional Info screen.
export function getAdditionalInfoFields(journey: JourneyData): FieldInfo[] {
  const fieldInfo = journey.transactionFieldsSendResponse?.fieldInfo ?? [];
  // Exclude additionalFields so the list stays stable while the user fills this screen.
  const collected = buildUpdateTransactionRequest(
    { ...journey, additionalFields: {} },
    ""
  )?.updateData;
  return fieldInfo
    .filter((f) => f.required === true && !getValueAtPath(collected, f.field))
    .sort((a, b) => Number(a.displayOrder ?? 0) - Number(b.displayOrder ?? 0));
}

export function requiresAdditionalInfo(journey: JourneyData): boolean {
  return getAdditionalInfoFields(journey).length > 0;
}
